export const MAX_VISIBLE_POINTS = 10;
export const MAX_VISIBLE_CHART_DOMAIN_MS = 184 * 24 * 60 * 60 * 1000; // 6 months in milliseconds

// NOTE: Requests from the API return data with different resolutions depending on the
// length of the time period and amount of points fetched.
export const FETCH_RESOLUTION_THRESHOLD_S = 2 * 60 * 60;
